var map = {
	"./": 76,
	"./App": 60,
	"./App.css": 161,
	"./App.js": 60,
	"./App.test": 162,
	"./App.test.js": 162,
	"./Pages": 42,
	"./Pages.js": 42,
	"./Utils": 5,
	"./Utils.js": 5,
	"./ajuda/Ajuda": 114,
	"./ajuda/Ajuda.css": 228,
	"./ajuda/Ajuda.js": 114,
	"./creditos/Creditos": 111,
	"./creditos/Creditos.css": 225,
	"./creditos/Creditos.js": 111,
	"./data/Chagas": 99,
	"./data/Chagas.js": 99,
	"./data/DataController": 98,
	"./data/DataController.js": 98,
	"./data/Esquistossomose": 100,
	"./data/Esquistossomose.js": 100,
	"./data/LeishTeg": 101,
	"./data/LeishTeg.js": 101,
	"./data/LeishVic": 102,
	"./data/LeishVic.js": 102,
	"./data/Leptospirose": 103,
	"./data/Leptospirose.js": 103,
	"./data/Malaria": 104,
	"./data/Malaria.js": 104,
	"./game/GamePage": 97,
	"./game/GamePage.js": 97,
	"./game/GameProvider": 40,
	"./game/GameProvider.js": 40,
	"./game/folder/Folder": 108,
	"./game/folder/Folder.css": 218,
	"./game/folder/Folder.js": 108,
	"./game/player/PlayerProvider": 19,
	"./game/player/PlayerProvider.js": 19,
	"./game/puzzle/ImageLoader": 74,
	"./game/puzzle/ImageLoader.js": 74,
	"./game/puzzle/Pieces": 51,
	"./game/puzzle/Pieces.js": 51,
	"./game/puzzle/Puzzle": 105,
	"./game/puzzle/Puzzle.css": 203,
	"./game/puzzle/Puzzle.js": 105,
	"./game/puzzle/modalWin/ModalWin": 106,
	"./game/puzzle/modalWin/ModalWin.css": 217,
	"./game/puzzle/modalWin/ModalWin.js": 106,
	"./game/puzzle/modalWin/warning/Warning": 107,
	"./game/puzzle/modalWin/warning/Warning.css": 216,
	"./game/puzzle/modalWin/warning/Warning.js": 107,
	"./game/score/Score": 109,
	"./game/score/Score.css": 224,
	"./game/score/Score.js": 109,
	"./game/timer/Timer": 110,
	"./game/timer/Timer.js": 110,
	"./globalProvider": 11,
	"./globalProvider.js": 11,
	"./index": 76,
	"./index.css": 229,
	"./index.js": 76,
	"./midias/images/eic/background.png": 594,
	"./midias/images/eic/eic_og.png": 595,
	"./midias/images/eic/logo.png": 596,
	"./midias/images/games/informs/chagas/1.png": 597,
	"./midias/images/games/informs/chagas/2.png": 598,
	"./midias/images/games/informs/chagas/3.png": 599,
	"./midias/images/games/informs/chagas/4.png": 600,
	"./midias/images/games/informs/chagas/5.png": 601,
	"./midias/images/games/informs/chagas/agenteChagas.png": 602,
	"./midias/images/games/informs/chagas/prevencChagas.png": 603,
	"./midias/images/games/informs/chagas/sintomChagas.png": 604,
	"./midias/images/games/informs/chagas/transmChagas.png": 605,
	"./midias/images/games/informs/chagas/vetorChagas.png": 606,
	"./midias/images/games/informs/esqui/1.png": 607,
	"./midias/images/games/informs/esqui/2.png": 608,
	"./midias/images/games/informs/esqui/3.png": 609,
	"./midias/images/games/informs/esqui/4.png": 610,
	"./midias/images/games/informs/esqui/5.png": 611,
	"./midias/images/games/informs/leishTeg/1.png": 612,
	"./midias/images/games/informs/leishTeg/2.png": 613,
	"./midias/images/games/informs/leishTeg/3.png": 614,
	"./midias/images/games/informs/leishTeg/4.png": 615,
	"./midias/images/games/informs/leishTeg/5.png": 616,
	"./midias/images/games/informs/leishTeg/Thumbs.db": 617,
	"./midias/images/games/informs/leishVic/1.png": 618,
	"./midias/images/games/informs/leishVic/2.png": 619,
	"./midias/images/games/informs/leishVic/3.png": 620,
	"./midias/images/games/informs/leishVic/4.png": 621,
	"./midias/images/games/informs/leishVic/5.png": 622,
	"./midias/images/games/informs/leptospirose/1.png": 623,
	"./midias/images/games/informs/leptospirose/2.png": 624,
	"./midias/images/games/informs/leptospirose/3.png": 625,
	"./midias/images/games/informs/leptospirose/4.png": 626,
	"./midias/images/games/informs/leptospirose/5.png": 627,
	"./midias/images/games/informs/malaria/1.png": 628,
	"./midias/images/games/informs/malaria/2.png": 629,
	"./midias/images/games/informs/malaria/3.png": 630,
	"./midias/images/games/informs/malaria/4.png": 631,
	"./midias/images/games/informs/malaria/5.png": 632,
	"./midias/images/games/informs/puzzles/play.png": 633,
	"./midias/images/games/puzzles/chagas/1.jpg": 634,
	"./midias/images/games/puzzles/chagas/2.jpg": 635,
	"./midias/images/games/puzzles/chagas/3.jpg": 636,
	"./midias/images/games/puzzles/chagas/4.jpg": 637,
	"./midias/images/games/puzzles/chagas/5.jpg": 638,
	"./midias/images/games/puzzles/esqui/1.jpg": 639,
	"./midias/images/games/puzzles/esqui/2.jpg": 640,
	"./midias/images/games/puzzles/esqui/3.jpg": 641,
	"./midias/images/games/puzzles/esqui/4.jpg": 642,
	"./midias/images/games/puzzles/esqui/5.jpg": 643,
	"./midias/images/games/puzzles/leishTeg/1.jpg": 644,
	"./midias/images/games/puzzles/leishTeg/2.jpg": 645,
	"./midias/images/games/puzzles/leishTeg/3.jpg": 646,
	"./midias/images/games/puzzles/leishTeg/4.jpg": 647,
	"./midias/images/games/puzzles/leishTeg/5.jpg": 648,
	"./midias/images/games/puzzles/leishVic/1.jpg": 649,
	"./midias/images/games/puzzles/leishVic/2.jpg": 650,
	"./midias/images/games/puzzles/leishVic/3.jpg": 651,
	"./midias/images/games/puzzles/leishVic/4.jpg": 652,
	"./midias/images/games/puzzles/leishVic/5.jpg": 653,
	"./midias/images/games/puzzles/lepto/1.jpg": 654,
	"./midias/images/games/puzzles/lepto/2.jpg": 655,
	"./midias/images/games/puzzles/lepto/3.jpg": 656,
	"./midias/images/games/puzzles/lepto/4.jpg": 657,
	"./midias/images/games/puzzles/lepto/5.jpg": 658,
	"./midias/images/games/puzzles/malaria/1.jpg": 659,
	"./midias/images/games/puzzles/malaria/2.jpg": 660,
	"./midias/images/games/puzzles/malaria/3.jpg": 661,
	"./midias/images/games/puzzles/malaria/4.jpg": 662,
	"./midias/images/games/puzzles/malaria/5.jpg": 663,
	"./midias/images/games/puzzles/play.png": 664,
	"./midias/images/layout/puzzle.jpg": 665,
	"./modal/Modal": 61,
	"./modal/Modal.css": 214,
	"./modal/Modal.js": 61,
	"./music/Music": 115,
	"./music/Music.css": 230,
	"./music/Music.js": 115,
	"./puzzleMenu/PuzzleMenu": 96,
	"./puzzleMenu/PuzzleMenu.css": 201,
	"./puzzleMenu/PuzzleMenu.js": 96,
	"./rank/Rank": 112,
	"./rank/Rank.css": 227,
	"./rank/Rank.js": 112,
	"./rank/select/Select": 113,
	"./rank/select/Select.css": 226,
	"./rank/select/Select.js": 113,
	"./serviceWorker": 231,
	"./serviceWorker.js": 231,
	"./setupTests": 232,
	"./setupTests.js": 232,
	"./sideMenu/SideMenu": 116,
	"./sideMenu/SideMenu.css": 263,
	"./sideMenu/SideMenu.js": 116,
	"./store/storeRanking": 41,
	"./store/storeRanking.js": 41,
	"./topMenu/TopMenu": 117,
	"./topMenu/TopMenu.css": 264,
	"./topMenu/TopMenu.js": 117
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 160;